<template>
  <!-- 产品分类列表 -->
  <div class="all-center-box">
    <div class="w-1500">
      <div class="address-box w-100 font-bold">
        <a @click="pageJump('/')">首页</a>
        <template v-if="parent != ''">
          / <a @click="skipPage">{{ parent.name }}</a></template
        >
        <template v-if="category != ''">
          / <a @click="reloadPage">{{ category.name }}</a></template
        >
      </div>
      <div class="product-sort w-100">
        <div class="ps-top w-100">{{ category.name }}</div>
        <div class="ps-left">
          <div class="box-info1 w-100" @click="reloadPage">
            {{ parent != '' ? parent.name : category.name }}
          </div>
          <div class="box-info2 w-100">
            <ul v-if="parentList.length > 0">
              <li
                v-for="(item, index) in parentList"
                :key="index"
                :class="[
                  { menu: item.children.length > 0 },
                  { active: item.id == category.id },
                ]"
                @click="changeChildren(item)"
              >
                <a>{{ item.name }}</a>
                <ul v-show="item.id == category.id">
                  <template>
                    <li
                      v-for="(item2, index2) in item.children"
                      :key="index2"
                      @click.stop="pageJump('/productTypeScreen', item2)"
                    >
                      <a @click.stop="changeUpdown(item2)">{{ item2.name }}</a>
                    </li>
                  </template>
                </ul>
              </li>
            </ul>
          </div>
        </div>
        <div class="ps-right">
          <div class="box-info1 w-100" v-if="parent == ''">
            在商品分类{{ category.name }}中搜索
          </div>
          <div class="box-info1 w-100" v-else>
            {{ category.name }}分类的一览表
          </div>
          <div v-for="(item, index) in categoryList">
            <div class="box-info2 w-100" :key="index">{{ item.name }}</div>
            <div class="box-info3 w-100" :key="item.id">
              <ul>
                <div
                  v-if="item.children.length > 0"
                  v-for="(item2, index2) in item.children"
                >
                  <li
                    @click.stop="pageJump('/productTypeScreen', item2)"
                    :key="index2"
                  >
                    <a>
                      <span
                        ><img
                          :src="
                            item2.coverUrl == ''
                              ? '/static/img/no_img.png'
                              : item2.coverUrl
                          "
                      /></span>
                      <p>{{ item2.name }}</p>
                    </a>
                  </li>
                </div>
                <template v-if="item.children.length == 0">
                  <li @click.stop="pageJump('/productTypeScreen', item)">
                    <a>
                      <span
                        ><img
                          :src="
                            item.coverUrl == ''
                              ? '/static/img/no_img.png'
                              : item.coverUrl
                          "
                      /></span>
                      <p>{{ item.name }}</p>
                    </a>
                  </li>
                </template>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  getCategories
} from '../../common/http.js'
export default {
  inject: ["reload"],
  data () {
    return {
      parent: '', // 父级类型
      category: '', // 当前类型
      parentList: [], // 分类列表
      categoryList: [], // 分类列表
      child: ""
    }
  },
  mounted () {
    if (this.$route.query.obj) {
      let parent = JSON.parse(decodeURIComponent(this.$route.query.obj));
      this.parent = parent
      this.getCategory(parent.uid)
    }
  },
  watch: {
    $route (to, from) {
      this.reload();
    }
  },
  methods: {
    getCategory (uid) {
      getCategories({
        uid: uid,
        isChildren: 1
      }).then(res => {
        if (res.result) {
          this.categoryList = this.parent.parent ? res.data : [{ children: res.data }]
          this.parentList = res.data
        }
      })
    },
    changeUpdown (item) {
      this.child = item.name;
      this.pageJump('/productTypeScreen', item)
    },
    changeChildren (item) {
      if (item.children.length <= 0) {
        this.pageJump('/productTypeScreen', item)
        return;
      } else {
        this.category = item;
        this.categoryList = [{
          children: item.children
        }]
      }
    },
    reloadPage () {
      this.getCategory(this.category.uid)
    },
    skipPage () {
      this.getCategory(this.parent.uid)
    },
    pageJump (url, data) {
      let params = {}
      if (data) {
        params.obj = data.id
        params.parent = this.parent.name
        params.child = this.category.name
        params.childrenName = data.name
      }
      this.$router.push({
        path: url,
        query: params
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/product/productType.vue